import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { Location } from 'history';
import {
    number_DAYS,
    ABOUT_ME_PROFILE,
    BEFORE_BIRTH_1,
    BEFORE_BIRTH_2,
    CHANGE,
    EDIT_PROFILE_SETTINGS,
    FAVORITE_USERS,
    HAVE_ME_AS_FAVORITE,
    I_AM_MEMBER_OF_GROUPS,
    PROFILE_SUMMARY__name_IS_in_num_pregnancy_week,
    PROFILE_SUMMARY__IN_num_PREGNANCY_WEEK,
} from 'mk/autogenerated/translations/MoreAboutMe.58941a9753c7026c4df95a52463cc11d'
import { canManageBlogs, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { capFirst } from 'mk/common/text';
import AboutProMe from 'mk2/apps/blogs/components/AboutProMe';
import AvatarImgGrid from 'mk2/apps/blogs/components/AvatarImgGrid';
import UserGroupsList from 'mk2/apps/blogs/components/UserGroupsList';
import { ProfileDetailData } from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers';
import { UserStrollers } from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollers';
import { SuggestedStrollerOption } from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.interfaces';
import { settingsProfileUrl } from 'mk2/apps/settings/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { cacheLast } from 'mk2/helpers/cache';
import { url } from 'mk2/helpers/urls';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './MoreAboutMe.mscss';

export enum AvatarGridType {
    FOLLOWERS = 'followers',
    FOLLOWING = 'following',
}

interface OwnProps {
    isMobile: boolean;
    location: Location;
    profileDetailData: ProfileDetailData;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    suggestedStrollerOptions: SuggestedStrollerOption[];
    onAddMyStroller(strollerId: number, username: string);
    onExpandAvatarGrid(avatarGridType: AvatarGridType, username: string);
    onExpandGroupList(username: string);
    onReloadStrollerSuggestions(searchTerm: string);
    onRemoveMyStroller(strollerId: number, username: string);
}

type Props = OwnProps;

export default class MoreAboutMe extends React.Component<Props> {

    private onExpandAvatarGridCache = cacheLast();
    private onExpandGroupListCache = cacheLast();

    public render() {
        const {
            isMobile,
            profileDetailData,
            requestUser,
            requestUserPermissions,
            suggestedStrollerOptions,
            onAddMyStroller,
            onExpandAvatarGrid,
            onExpandGroupList,
            onReloadStrollerSuggestions,
            onRemoveMyStroller,
        } = this.props;

        const isBlogsAdmin = canManageBlogs(requestUserPermissions);
        const isOwner = isAuthenticatedAs(requestUser, profileDetailData.user);

        const {
            followers, following, memberOfGroups, pregnancyDaysCounter, pregnancyWeekNumber, user, userAboutMeText,
            userStrollers, userStrollersReviews, userVendorData,
        } = profileDetailData;

        return (
            <div className={styles.MoreAboutMe}>

                {isMobile &&
                    (
                        !!userAboutMeText && userAboutMeText.trim() ||
                        isOwner
                    ) &&
                (
                    <div className={styles.MoreAboutMe__about}>
                        <h2>{ABOUT_ME_PROFILE}</h2>
                        {!!userAboutMeText && userAboutMeText.trim() && (
                             <div className={styles.MoreAboutMe__about__aboutMeText}>
                                {userAboutMeText}
                            </div>
                        )}
                        {isOwner && (
                            <div className={styles.MoreAboutMe__about__edit}>
                                <Btn
                                    type={BtnType.Link}
                                    link={url(settingsProfileUrl, { username: user.username })}
                                    icon={faEdit}
                                    sidePadding={0}
                                    label={EDIT_PROFILE_SETTINGS}
                                />
                            </div>
                        )}
                    </div>
                )}

                {pregnancyDaysCounter && pregnancyWeekNumber && (
                    <div className={styles.MoreAboutMe__pregnancyState}>
                        <Interpolate
                            i18nKey={PROFILE_SUMMARY__name_IS_in_num_pregnancy_week}
                            name={capFirst(user.username)}
                            in_num_pregnancy_week={interpolate(PROFILE_SUMMARY__IN_num_PREGNANCY_WEEK, {count: pregnancyWeekNumber, num: pregnancyWeekNumber})}
                        />. {isOwner || isBlogsAdmin && <Link to={url(settingsProfileUrl, { username: user.username })}>{CHANGE}</Link>}
                        <br />
                        {BEFORE_BIRTH_1} <b>
                            {interpolate(number_DAYS, {count: pregnancyDaysCounter, number: pregnancyDaysCounter})}
                        </b> {BEFORE_BIRTH_2}
                    </div>
                )}

                {userVendorData && (
                    <AboutProMe
                        isMobile={isMobile}
                        profileDetailData={profileDetailData}
                        requestUser={requestUser}
                        requestUserPermissions={requestUserPermissions}
                    />
                )}

                {(isBlogsAdmin || isOwner || (userStrollers && userStrollers.length > 0)) && (
                    <div className={styles.MoreAboutMe__strollers}>
                        <UserStrollers
                            isAdmin={isBlogsAdmin}
                            isOwner={isOwner}
                            onAddMyStroller={onAddMyStroller}
                            onReloadStrollerSuggestions={onReloadStrollerSuggestions}
                            onRemoveMyStroller={onRemoveMyStroller}
                            renderBlankInit={false}
                            reviews={userStrollersReviews}
                            strollers={userStrollers}
                            suggestedStrollerOptions={suggestedStrollerOptions}
                            username={user.username}
                        />
                    </div>

                )}

                {(isOwner || isBlogsAdmin) && following.count > 0 && (
                    <AvatarImgGrid
                        countAll={following.count}
                        expanded={following.expanded}
                        hasMore={following.hasMore}
                        header={FAVORITE_USERS}
                        isMobile={isMobile}
                        loadingState={LoadingState.SUCCESS}
                        maxLinesCountIfCollapsed={2}
                        users={following.users}
                        onExpand={
                            this.onExpandAvatarGridCache(() => {
                                onExpandAvatarGrid(AvatarGridType.FOLLOWING, user.username);
                            }, user, AvatarGridType.FOLLOWING)
                        }
                    />
                )}

                {followers.count > 0 && (
                    <AvatarImgGrid
                        countAll={followers.count}
                        expanded={followers.expanded}
                        hasMore={followers.hasMore}
                        header={HAVE_ME_AS_FAVORITE}
                        isMobile={isMobile}
                        loadingState={LoadingState.SUCCESS}
                        maxLinesCountIfCollapsed={2}
                        users={followers.users}
                        onExpand={
                            this.onExpandAvatarGridCache(() => {
                                onExpandAvatarGrid(AvatarGridType.FOLLOWERS, user.username);
                            }, user, AvatarGridType.FOLLOWERS)
                        }
                    />
                )}

                {memberOfGroups.count > 0 && (
                    <UserGroupsList
                        countAll={memberOfGroups.count}
                        hasMore={memberOfGroups.hasMore}
                        header={I_AM_MEMBER_OF_GROUPS}
                        loadingState={LoadingState.SUCCESS}
                        groups={memberOfGroups.groups}
                        onExpand={
                            this.onExpandGroupListCache(() => {
                                onExpandGroupList(user.username);
                            }, user)
                        }
                    />
                )}

            </div>
        );
    }
}
